import { call, takeLatest } from "redux-saga/effects";

import {
  STOCK_AUDIT_CREATE,
  STOCK_AUDIT_UPLOAD_CSV,
  STOCK_AUDIT_EDIT,
  STOCK_AUDIT_TABLE,
  STOCK_AUDIT_VIEW,
  STOCK_DETAILS_BATCH_DROP_DOWN,
  STOCK_DETAILS_BATCH_UPDATE,
  STOCK_DETAILS_BATCH_VIEW,
  STOCK_DETAILS_ITEMS_FETCH,
  STOCK_DETAILS_ITEM_VIEW,
  STOCK_AUDIT_LOAD_FILTERS,
  STOCK_AUDIT_DELETE,
} from "../types";
import {
  stockAuditCreateApi,
  stockAuditUploadCsvApi,
  stockAuditEditApi,
  stockAuditTableApi,
  stockAuditViewApi,
  stockDetailsBatchDropDownApi,
  stockDetailsBatchUpdateApi,
  stockDetailsBatchViewApi,
  stockDetailsItemViewApi,
  stockDetailsItemsFetchApi,
  stockAuditLoadFiltersApi,
  stockAuditDeleteApi,
} from "../apis/stock-details-audit-api";

export function* stockDetailsItemsFetchWorker(action) {
  try {
    const res = yield call(stockDetailsItemsFetchApi, action.data);

    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockDetailsItemViewWorker(action) {
  try {
    const res = yield call(stockDetailsItemViewApi, action.data);

    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockDetailsBatchUpdateWorker(action) {
  try {
    const res = yield call(stockDetailsBatchUpdateApi, action.data);

    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockDetailsBatchDropDownWorker(action) {
  try {
    const res = yield call(stockDetailsBatchDropDownApi, action.data);

    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockDetailsBatchViewWorker(action) {
  try {
    const res = yield call(stockDetailsBatchViewApi, action.data);

    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockAuditCreateWorker(action) {
  try {
    const res = yield call(stockAuditCreateApi, action.data);

    if (res.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stockAuditTableWorker(action) {
  try {
    const res = yield call(stockAuditTableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stockAuditViewWorker(action) {
  try {
    const res = yield call(stockAuditViewApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stockAuditUploadCsvWorker(action) {
  try {
    const res = yield call(stockAuditUploadCsvApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockAuditLoadFiltersWorker(action) {
  try {
    const res = yield call(stockAuditLoadFiltersApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockAuditEditWorker(action) {
  try {
    const res = yield call(stockAuditEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stockAuditDeleteWorker(action) {
  try {
    const res = yield call(stockAuditDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* stockAuditCreateWatcher() {
  yield takeLatest(STOCK_AUDIT_CREATE, stockAuditCreateWorker);
}
export function* stockAuditDeleteWatcher() {
  yield takeLatest(STOCK_AUDIT_DELETE, stockAuditDeleteWorker);
}
export function* stockAuditTableWatcher() {
  yield takeLatest(STOCK_AUDIT_TABLE, stockAuditTableWorker);
}
export function* stockAuditViewWatcher() {
  yield takeLatest(STOCK_AUDIT_VIEW, stockAuditViewWorker);
}
export function* stockAuditEditWatcher() {
  yield takeLatest(STOCK_AUDIT_EDIT, stockAuditEditWorker);
}
export function* stockAuditUploadCsvWatcher() {
  yield takeLatest(STOCK_AUDIT_UPLOAD_CSV, stockAuditUploadCsvWorker);
}
export function* stockAuditLoadFiltersWatcher() {
  yield takeLatest(STOCK_AUDIT_LOAD_FILTERS, stockAuditLoadFiltersWorker);
}

export function* stockDetailsItemsFetchWatcher() {
  yield takeLatest(STOCK_DETAILS_ITEMS_FETCH, stockDetailsItemsFetchWorker);
}
export function* stockDetailsItemViewWatcher() {
  yield takeLatest(STOCK_DETAILS_ITEM_VIEW, stockDetailsItemViewWorker);
}
export function* stockDetailsBatchUpdateWatcher() {
  yield takeLatest(STOCK_DETAILS_BATCH_UPDATE, stockDetailsBatchUpdateWorker);
}
export function* stockDetailsBatchDropDownWatcher() {
  yield takeLatest(
    STOCK_DETAILS_BATCH_DROP_DOWN,
    stockDetailsBatchDropDownWorker
  );
}
export function* stockDetailsBatchViewWatcher() {
  yield takeLatest(STOCK_DETAILS_BATCH_VIEW, stockDetailsBatchViewWorker);
}
